<template>
  <div>
    <SPreloader />
    <SSubHeader :pageName="'How to earn Swampum points'" :backButton="true" />
    <div class="header-spacer header-spacer-small"></div>
    <md-content class="page-content">
      <md-content class="md-elevation-10 center-content">
        <ExplanationHowEarnPoints />
        <SButtonMaterial
          class="share-btn"
          buttonType="button"
          color="primary"
          textColor="white"
          materialClass="dense"
          text="Share now"
          data-cy="shareSwampum-btn"
          to="/s-app/invite-friends"
        />
      </md-content>
    </md-content>
  </div>
</template>

<script>
import SPreloader from "@/components/organisms/SPreloader.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import ExplanationHowEarnPoints from "@/material-components/atoms/ExplanationHowEarnPoints.vue";
export default {
  name: "HowToEarnPoints",
  components: {
    SPreloader,
    SSubHeader,
    SButtonMaterial,
    ExplanationHowEarnPoints,
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  justify-content: center;
  background-color: #f4f4f4;
  margin-top: 3rem;
}
.center-content {
  width: 86%;
  height: 90%;
  min-height: 80vh;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  border-radius: 5px;
  margin: 2rem 0 2rem 0;
  display: flex;
  flex-direction: column;
}

.share-btn {
  align-self: center;
  margin-bottom: 40px;
  width: 160px;
  height: 40px;
  border-radius: 5px;
}

@media (max-width: 1024px) {
  .page-content {
    margin-top: 7rem;
  }
}
@media (min-width: 1400px) {
  .center-content {
    max-width: 1270px;
    margin-left: auto;
    margin-right: auto;
  }

}
</style>
